import { SvgIcon } from '@progress/kendo-react-common';
import { Drawer, DrawerContent, DrawerItem } from "@progress/kendo-react-layout";
import { chevronDownIcon, chevronRightIcon, clockArrowRotateIcon, fileReportIcon, fileWrenchIcon, redditIcon, userIcon } from '@progress/kendo-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserContext } from '../../../context/UserContext';
import Images from '../../../custom/flagExport';
import Navbar from './Navbar';

const regions = [
    { id: 6, name: 'English', value: 'en', flag: Images["uk"] }, // UK
    { id: 2, name: 'Svenska ', value: "sv", flag: Images["se"] }, // Sweden
    { id: 1, name: 'Suomi', value: "fi", flag: Images["fi"] }, // Finland
];

const CustomItem = React.memo(props => {
    const {
        visible,
        ...others
    } = props;
    const arrowDir = props.dataexpanded ? chevronDownIcon : chevronRightIcon;
    return props.visible === false ? null : <DrawerItem {...others}>
        <SvgIcon icon={props.svgIcon} />
        <span className={'k-item-text'}>{props.text}</span>
        {props.dataexpanded !== undefined && <SvgIcon icon={arrowDir} style={{
            marginLeft: 'auto'
        }} />}
    </DrawerItem>;
});



const NavbarComponent = props => {
    const navigate = useNavigate();
    const { t, i18n } = useTranslation();
    // const [showProfileMenu, setShowProfileMenu] = React.useState(false);
    const [selectedRegion, setSelectedRegion] = React.useState(regions[0])
    const location = useLocation();
    // const [anchorEl, setAnchorEl] = React.useState(null);

    const { user, setUser } = useUserContext()
    const [renderRoute, setRenderRoute] = React.useState("")


    const [drawerExpanded, setDrawerExpanded] = React.useState(true);
    const [items, setItems] = React.useState([]);



    const adminItems = [
        {
            text: t("UserManagement"),
            svgIcon: userIcon,
            id: 2,
            title: "UserManagement",
            selected: false,
            route: '/user-management'
        },
        // Add more admin-specific items here
    ];


    const defaultUserItems = [
        {
            text: t('VehicleVIOReport'),
            svgIcon: fileWrenchIcon,
            id: 1,
            title: "VehicleVIOReport",
            selected: false,
            route: '/'
        }
        , {
            text: t('ArticleVIOReport'),
            svgIcon: fileReportIcon,
            id: 3,
            title: "ArticleVIOReport",
            selected: false,
            route: '/article'
        },
    ];

    const defaultItems = [
        {
            text: t('History'),
            svgIcon: clockArrowRotateIcon,
            id: 4,
            title: "History",
            selected: false,
            route: '/history'
        }
    ]


    // const chatbotItems = [
    //     {
    //         text: t('Chatbot'),
    //         svgIcon: redditIcon,
    //         id: 5,
    //         title: "Chatbot",
    //         selected: false,
    //         route: '/chatbot'
    //     }
    // ]


    const role = user?.UserRole;
    // const email = user?.Email?.toLowerCase()
    const routes = user?.routes
    const routesSplitedArray = routes?.map((item) => item?.route_name?.toLowerCase())

    React.useEffect(() => {
        if (role === 'ROOT') {
            setItems([...defaultUserItems, ...defaultItems, ...adminItems]);
        } else {
            if (routesSplitedArray && routesSplitedArray.includes("chatbot")) {
                // setItems([...chatbotItems])
                return;
            }
            const accessibleItems = defaultUserItems?.filter(item => routes?.some((route) => route?.route_name === item?.title && route?.route === item?.route)
            ) || []
            setItems([...accessibleItems, ...defaultItems]);
        }
    }, [role, t]);

    React.useEffect(() => {
        if (user?.routes && user.routes.length > 0) {
            setRenderRoute(user.routes[0].route);
        } else {
            setRenderRoute("/"); // fallback
        }
    }, [user]);




    // Use memoization to store current route for optimization
    const currentRoute = location.pathname;

    // Sync the route with selected menu item on mount or route change
    React.useEffect(() => {
        const updatedItems = items.map(item => ({
            ...item,
            selected: item.route === currentRoute
        }));

        const isDifferent = updatedItems.some((item, index) => item.selected !== items[index].selected);
        if (isDifferent) {
            setItems(updatedItems);
        }
    }, [currentRoute, items]);

    React.useEffect(() => {
        const currentLang = i18n.language || "en";
        const selected = regions.find(region => region.value === currentLang);
        setSelectedRegion(selected);
    }, []);



    const onSelect = ev => {
        const currentItem = ev.itemTarget.props;
        const isParent = currentItem.dataexpanded !== undefined;
        const nextExpanded = !currentItem.dataExpanded;

        setItems(prevItems => prevItems.map(item => {
            const isCurrentItem = currentItem.id === item.id;
            return {
                ...item,
                selected: isCurrentItem,
                dataexpanded: isCurrentItem && isParent ? nextExpanded : item.dataexpanded
            };
        }));

        navigate(currentItem.route);
    };


    return (
        <div>
            <Navbar user={user} setSelectedRegion={setSelectedRegion} setDrawerExpanded={setDrawerExpanded} setUser={setUser} selectedRegion={selectedRegion} renderRoute={renderRoute} />
            <Drawer expanded={drawerExpanded} mode='push' width={240} items={items} item={CustomItem} onSelect={onSelect}>
                <DrawerContent>
                    {props.children}
                </DrawerContent>
            </Drawer>
        </div>
    );
};

export default NavbarComponent;